var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon__search--system icon--style--outline icon--size--small",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.799 14.74l-5.37-5.368a5.82 5.82 0 10-1.057 1.057l5.368 5.368a.75.75 0 001.059-1.059zM1.529 5.835a4.307 4.307 0 114.307 4.306 4.307 4.307 0 01-4.307-4.306z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }